import { Component } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent {

  customOptions: OwlOptions = {
    loop: true,
    autoplay: true,
    margin: 20,
    slideTransition: 'linear',
    autoplayTimeout: 2000,
    autoplaySpeed: 10000,
    dots: false,
    responsive: {
      0: {
        items: 1,
      },
      480: {
        items: 2,
      },
      768: {
        items: 3,
      },
      1520: {
        items: 4,
      },
      1900: {
        items: 4,
      }
    }
  }

  constructor() {
  }
}
